<template>
    <div>
        <div v-if="this.params.data.transactionCode"
                @click="showModal"
                class="pointer accent_color text-dense">
            TB-{{ this.params.data.transactionCode}}
        </div>
    </div>
</template>

<script>
	export default {
		methods: {
			showModal() {
				this.params.showModal(this.params.data)
			}
		}
	};
</script>